import { render } from "./referee-sidebar.vue?vue&type=template&id=42a0edba&scoped=true"
import script from "./referee-sidebar.vue?vue&type=script&lang=js"
export * from "./referee-sidebar.vue?vue&type=script&lang=js"

import "./referee-sidebar.vue?vue&type=style&index=0&id=42a0edba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a0edba"]])

export default __exports__